export default __webpack_public_path__ + "static/media/people-toast.1f5198bc.png";